import {ENC} from './decrypt_pwd'

export const domain = '/smee'
export const redmineDomain = 'https://smee.gapinc.com'

export const redmineApiKey = ENC('U2FsdGVkX1+HEyD02h8pcKqBHm92dZW/Yd+KfZdBqI+9JmDJEIEPVuaSSpdRpM8LUpOnG76d/FIJkDMyqf1bvg==')



// WEBPACK FOOTER //
// ./src/app_config.js